import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import { Message, MessageType } from "../alerts/Message.js";
import "react-intl";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  autocompleteInfoMessageSubMessage: {
    color: theme.palette.warning.main,
    margin: theme.spacing(1, 0),
    ...theme.typography.body2,
    display: "block"
  },
  autocompleteInfoMessageSubMessageIcon: {
    fontSize: theme.typography.body2.fontSize,
    marginRight: theme.spacing(1.25)
  },
  autocompleteInfoMessage: {
    ...theme.typography.caption,
    padding: theme.spacing(0.5),
    whiteSpace: "normal"
  }
}));
function AutocompleteInfoMessage({
  containerRef,
  hideMessage,
  dataTestId,
  message,
  messageOrientation,
  subInfoMessage,
  autocompleteState
}) {
  const { classes: styles } = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, subInfoMessage && autocompleteState ? /* @__PURE__ */ React.createElement(Box, { component: "span", className: styles.autocompleteInfoMessageSubMessage }, /* @__PURE__ */ React.createElement(
    Icon,
    {
      color: IconColor.InProgress,
      icon: CustomIcon.WarningOutline,
      className: styles.autocompleteInfoMessageSubMessageIcon
    }
  ), subInfoMessage) : null, /* @__PURE__ */ React.createElement(
    Message,
    {
      hideMessage,
      containerRef,
      dataTestId,
      className: styles.autocompleteInfoMessage,
      message,
      variant: "inherit",
      messageType: MessageType.Error,
      messageOrientation
    }
  ));
}
export {
  AutocompleteInfoMessage
};
//# sourceMappingURL=AutocompleteInfoMessage.js.map
